import { combineReducers } from "@reduxjs/toolkit";
import { authSlice } from "./authSlice";
import { adminSlice } from './adminSlice';
import { loadingSlice } from "./loadingSlice";
const reducers = combineReducers({
    auth: authSlice.reducer,
    admin: adminSlice.reducer,
    loading : loadingSlice.reducer
});

export default reducers